import { Button, Layout, Spin } from 'antd'
import React, { useEffect, useState, useContext } from 'react'
import { useParams } from 'react-router'
import { useForm } from 'antd/es/form/Form'
import { get, put } from '../../Common/api'
import { t } from 'i18next'
import TeleconsultingCompanyForm from '../TeleconsultingCompaniesPage/TeleconsultingCompanyForm'
import { Color } from '../../Common/Color'
import GlobalContext from '../GlobalContext'
import { ActionButton } from '../../Common/Common'
import LoginContext from '../LoginContext'

export default function TeleconsultingCompanyPage () {
  const { id } = useParams()
  const [form] = useForm()
  const [loading, setLoading] = useState(false)
  const [teleconsultingCompany, setTeleconsultingCompany] = useState()
  const { notificationApi } = useContext(GlobalContext)
  const { user } = useContext(LoginContext)

  useEffect(() => {
    getTeleconsultingCompany()
  }, [])

  const getTeleconsultingCompany = async () => {
    setLoading(true)
    await get({
      url: `admin/teleconsulting_companies/${id}`,
      params: {},
      onSuccess: (json) => {
        setLoading(false)
        setTeleconsultingCompany(json)
        form.setFieldsValue(json)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const onFinish = (values) => {
    saveTeleconsultingCompany(values)
  }

  const saveTeleconsultingCompany = (params) => {
    setLoading(true)
    put({
      url: `admin/teleconsulting_companies/${id}`,
      params,
      notification: { api: notificationApi, state: 'update' },
      onSuccess: () => {
        setLoading(false)
      },
      onFailure: (errors) => {
        setLoading(false)
        form.setFields(
          Object.keys(errors).map((key) => ({
            name: key,
            errors: errors[key]
          }))
        )
      }
    })
  }

  return (
    <>
      { teleconsultingCompany &&
        <>
          <Layout style={{ padding: '1em 0', color: Color.dark_blue, fontSize: '24px' }}>
            {`${t('Admin.TeleconsultingCompanyPage.title')} "${teleconsultingCompany.name}"`}
          </Layout>
          <Layout style={{ padding: '1em', backgroundColor: 'white', marginTop: '2em' }}>
            <Spin spinning={loading}>
              <TeleconsultingCompanyForm form={form} onFinish={onFinish} tc={teleconsultingCompany} disabled={user.roles.includes('reader')} />
              <ActionButton type="primary" htmlType="submit" onClick={form.submit}>
                {t('Admin.btn.submit')}
              </ActionButton>
            </Spin>
          </Layout>
        </>
      }
    </>
  )
}
